import { BANK_ACCOUNT_PAGE } from "routes/route.constant";
import BankAccount from "./BankAccount";

const route = {
  path: BANK_ACCOUNT_PAGE,
  element: BankAccount,
};

export default route;
